(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.panels.forEach((panel) => {
          panel.querySelector('.product-tabs__acc-head')?.addEventListener('click', (event) => {
            const open = !panel.classList.contains('is-open');
            panel.classList.toggle('is-open', open);
            event.currentTarget.setAttribute('aria-expanded', String(open));
          });
        });
        this.querySelector('.product-tabs__nav')?.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(document.activeElement);
          if (index < 0 || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
          const next = this.tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
          next.focus();
          this.select(next);
        });
      }

      select(selected) {
        this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab === selected)));
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== selected.dataset.panel;
          panel.classList.toggle('is-open', !panel.hidden);
          panel.querySelector('.product-tabs__acc-head')?.setAttribute('aria-expanded', String(!panel.hidden));
        });
      }
    }

    customElements.define('product-tabs', ProductTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
